import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import heic2png from 'heic2any';

function App() {
  const [images, setImages] = useState([]);
  const [convertedImages, setConvertedImages] = useState([]);
  const [uploadStatus, setUploadStatus] = useState('');

  const onDrop = (acceptedFiles) => {
    const newImages = acceptedFiles.map((file) => {
      if (file.type === 'image/heic') {
        return convertHeicToPng(file);
      } else {
        return Promise.resolve(URL.createObjectURL(file));
      }
    });

    Promise.all(newImages).then((imageURLs) => {
      setImages(imageURLs);
    });
  };

  const convertHeicToPng = async (file) => {
    try {
      const buffer = await file.arrayBuffer();
      const pngBlob = await heic2png(buffer);
      return URL.createObjectURL(pngBlob);
    } catch (error) {
      console.error("Error converting HEIC:", error);
      return null;
    }
  };

  const handleUpload = async () => {
    const formData = new FormData();
    
    images.forEach((imageURL, index) => {
      const imageFile = imageURL instanceof Blob ? imageURL : dataURLtoBlob(imageURL);
      formData.append('images[]', imageFile, `image${index}.png`);
    });

    try {
      setUploadStatus('Uploading...');
      const response = await fetch('upload.php', {
        method: 'POST',
        body: formData,
      });
      const result = await response.json();
      setUploadStatus(result.message || 'Upload Successful');
    } catch (error) {
      setUploadStatus('Upload Failed');
      console.error('Error uploading:', error);
    }
  };

  // Convert data URL to Blob for file upload
  const dataURLtoBlob = (dataURL) => {
    const byteString = atob(dataURL.split(',')[1]);
    const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/*',
    onDrop,
    multiple: true,  // Allow multiple files
  });

  return (
    <div className="App">
      <h1>Upload Images</h1>
      <div {...getRootProps()}>
        <input {...getInputProps()} />
        <p>Drag & drop images here, or click to select files</p>
      </div>
      <div>
        {images.map((image, index) => (
          <img key={index} src={image} alt={`preview-${index}`} width="100" />
        ))}
      </div>
      <button onClick={handleUpload}>Upload All</button>
      <p>{uploadStatus}</p>
    </div>
  );
}

export default App;
